// @flow
import React, {Component} from 'react';
import {StyleSheet, View} from 'react-native';
import {
  DownloadAppOnStore,
  FullButton,
  GradientPage,
} from '../../../components/common';
import RequiredItemCarousel from '../../../components/signUp/RequiredItemCarousel.web';
import I18n from '../../../lib/i18n';
import PageTitle from '../../../components/signUp/PageTitle.web';

type Props = {
  goToSimOrEsimPage: Function,
  isInitializingSignUp: boolean,
};

/* eslint-disable global-require */
const REQUIRED_ITEMS = [
  {
    itemCount: '1',
    itemDescription: I18n.t('SignUp.RequiredToSignUp.yourOffer'),
    iconName: 'phone',
  },
  {
    itemCount: '2',
    itemDescription: I18n.t('SignUp.RequiredToSignUp.yourAccount'),
    iconName: 'user',
  },
  {
    itemCount: '3',
    itemDescription: I18n.t('SignUp.RequiredToSignUp.yourCreditCard'),
    iconName: 'creditcard',
  },
  {
    itemCount: '4',
    itemDescription: I18n.t('SignUp.RequiredToSignUp.chooseSim'),
    iconName: 'sim',
  },
];

class RequiredToSignUp extends Component<Props> {
  render() {
    return (
      <GradientPage>
        <View style={styles.container}>
          <PageTitle
            title={I18n.t('SignUp.RequiredToSignUp.title')}
            subtitle={I18n.t('SignUp.RequiredToSignUp.youWill')}
          />

          <RequiredItemCarousel
            items={REQUIRED_ITEMS}
            autoScrollDuration={4000}
          />

          <FullButton
              text={I18n.t('SignUp.RequiredToSignUp.getStarted')}
              onPress={this.props.goToSimOrEsimPage}
              style={styles.button}
              textStyle={styles.buttonTextStyle}
              isLoading={this.props.isInitializingSignUp}
            />

          <View style={styles.footerContent}>

            <DownloadAppOnStore />

            
          </View>
        </View>
      </GradientPage>
    );
  }
}

const styles = StyleSheet.create({
  container: {
    width: '100%',
    alignItems: 'center',
  },
  footerContent: {
    width: '100%',
    maxWidth: 800,
    marginTop: 5,
    alignItems: 'center',
  },
  separator: {
    color: '#DDDDDF',
    width: '100%',
    marginBottom: 30,
  },
  button: {
    width: '100%',
    maxWidth: 600,
    height: 50,
    marginTop: 40,
    marginBottom: 20,
  },
  buttonTextStyle: {
    fontWeight: '600',
  },
});

export default RequiredToSignUp;
